import { FILTER_LIST, BASIC_STATE, STUDENT_GALLERY, ACTIVE_STUDENT, STUDENTS_DATA, USER_DATA, SET_FILTERS, ASSOCIATED_TEACHERS, STUDENT_ACTIVE_PAGE, TEACHER_ACTIVE_PAGE, GALLERY_STUDENT_LIST, GALLERY_FILTER, STUDENT_FILTER, TEACHER_FILTER, USER_FILTER, RESET_FILTERS, ACTIVE_QUIZ_STUDENT, QUIZ_STUDENT_ACTIVE_PAGE } from "../actions/types";

const initialState = {
   filters: { filterLevel: [], filters: {} },
   studentFilter: {
      classes: [],
      developmentPillars: [],
      programs: [],
      schools: [],
      sections: [],
      teachers: []
   },
   teacherFilter: {
      classes: [],
      developmentPillars: [],
      programs: [],
      schools: [],
      sections: [],
      teachers: []
   },
   userFilter: {
      classes: [],
      developmentPillars: [],
      programs: [],
      schools: [],
      sections: [],
      teachers: []
   },
   galleryFilter: {
      classes: [],
      developmentPillars: [],
      programs: [],
      schools: [],
      sections: [],
      teachers: [],
      kidIds: []
   },
   studentActivePage: 1,
   quizStudentActivePage: 1,
   teacherActivePage: 1,
   basicStats: {},
   studentGallery: [],
   activeStudents: {},
   activeQuizStudents: {},
   associatedTeachers: {},
   studentData: {},
   userData: {},
   galleryStudentList: {}
}

export default function (state = initialState, action) {

   const { type, payload } = action;

   switch (type) {
      case FILTER_LIST:
         return { ...state, filters: payload }
      case BASIC_STATE:
         return { ...state, basicStats: payload }
      case ACTIVE_STUDENT:
         return { ...state, activeStudents: payload }
      case ACTIVE_QUIZ_STUDENT:
         return { ...state, activeQuizStudents: payload }
      case ASSOCIATED_TEACHERS:
         return { ...state, associatedTeachers: payload }
      case STUDENT_GALLERY:
         return { ...state, studentGallery: payload }
      case STUDENTS_DATA:
         return { ...state, studentData: payload }
      case USER_DATA:
         return { ...state, userData: payload }
      case STUDENT_FILTER:
         return { ...state, studentFilter: payload }
      case TEACHER_FILTER:
         return { ...state, teacherFilter: payload }
      case USER_FILTER:
         return { ...state, userFilter: payload }
      case STUDENT_ACTIVE_PAGE:
         return { ...state, studentActivePage: payload }
      case QUIZ_STUDENT_ACTIVE_PAGE:
         return { ...state, quizStudentActivePage: payload }
      case TEACHER_ACTIVE_PAGE:
         return { ...state, teacherActivePage: payload }
      case GALLERY_STUDENT_LIST:
         return { ...state, galleryStudentList: payload }
      case GALLERY_FILTER: {
         return { ...state, galleryFilter: payload }
      }
      case RESET_FILTERS: {
         return {
            ...state, studentFilter: {
               classes: [],
               developmentPillars: [],
               programs: [],
               schools: [],
               sections: [],
               teachers: []
            },
            teacherFilter: {
               classes: [],
               developmentPillars: [],
               programs: [],
               schools: [],
               sections: [],
               teachers: []
            },
            userFilter: {
               classes: [],
               developmentPillars: [],
               programs: [],
               schools: [],
               sections: [],
               teachers: []
            },
            galleryFilter: {
               classes: [],
               developmentPillars: [],
               programs: [],
               schools: [],
               sections: [],
               teachers: [],
               kidIds: []
            },
         }
      }
      default:
         return state;
   }
}